module.exports = __webpack_public_path__ + "static/media/sf-test-11.99a7d6e7.mp3";